export default "__VITE_ASSET__0pKNCcfJ__"